























































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { TableItem, TableHeaderItem } from '@/utils/types'
import { Product, ProductCharacter } from '../../store/modules/lib'
import ITrash from '@/components/icons/ITrash.vue'

@Component({
  components: {
    'i-trash': ITrash,
  }
})
export default class ProductDlgCharacters extends Vue {
  @Prop({ type: Object, default: {} }) protected value!: Product

  protected headers: TableHeaderItem[] = []

  protected chTitle: string = ''
  protected chValue: string = ''

  protected addDlgState: boolean = false
  protected editId: string = ''

  protected edit (item: ProductCharacter): void {
    this.editId = `${ item.title }:::${ item.value }`
    this.chTitle = item.title
    this.chValue = item.value
    this.addDlgState = true
  }

  protected save() {
    this.addDlgState = false

    if (!this.editId) {
      this.value.characters.push({
        title: this.chTitle,
        value: this.chValue,
        description: ''
      })
    } else {
      this.value.characters = [...this.value.characters].map(v => {
        if (`${ v.title }:::${ v.value }` === this.editId) {
          return {
            ...v,
            title: this.chTitle,
            value: this.chValue
          }
        }

        return v
      })
    }
    this.chTitle = ''
    this.chValue = ''
    this.$emit('input', this.value)
  }

  protected get items(): TableItem[] {
    return this.value.characters.map((ch: ProductCharacter) => {
      return {
        title: ch.title,
        value: ch.value,
      }
    });
  }

  protected add() {
    this.chTitle = '';
    this.chValue = '';
    this.addDlgState = true;
  }

  protected drop(ch: ProductCharacter) {

    this.addDlgState = false;

    let value: any = this.value;

    this.value.characters = this.value.characters.filter(c => c.title != ch.title || c.value != ch.value);

    this.$emit('input', value);

  }

  // protected beforeMount() {

  //   this.headers = [
  //     {
  //       value: 'title',
  //       text: 'Название',
  //     },
  //     {
  //       value: 'value',
  //       text: 'Значение',
  //     },
  //   ];

  // }

}

